module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal view dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('view-header', {
    attrs: {
      "title": "Reservation details"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Overview"
    }
  }, [_c('overview'), _vm._v(" "), _c('stats')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Reservation details"
    }
  }, [_c('more')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.getClonedReservation.status !== -5) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeActions),
      expression: "closeActions"
    }],
    staticClass: "relative mr-auto"
  }, [_c('button', {
    staticClass: "btn tertiary m-0 wider",
    on: {
      "click": _vm.toggleActions
    }
  }, [_vm._v("Actions")]), _vm._v(" "), (_vm.showActions) ? _c('ul', {
    staticClass: "floating-menu top wide"
  }, [_c('li', [_vm._v("Send by email")]), _vm._v(" "), _c('li', [_vm._v("Print")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.reschedule
    }
  }, [_vm._v("Reschedule")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel reservation")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getClonedReservation.status !== -5) ? _c('div', [_c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToPayment
    }
  }, [_vm._v("Pay")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-159b611b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159b611b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationView.vue
// module id = 1270
// module chunks = 0